import { useEffect } from "react";
import { WithDefaultLayout } from "@/components/DefautLayout";
import { Page } from "@/types/Page";
import { useRouter } from "next/router";
import { useSession } from "next-auth/react";
import { UserInfo } from "@/functions/AuthorizationContext";
import { useFetchWithAccessToken } from "@/functions/useFetchWithAccessToken";
import { BackendApiUrl } from "@/functions/BackendApiUrl";
import { useAtomValue } from "jotai";
import { permissionsAtom } from "@/stores/permissionAtom";

interface CheckUnverifiedResponse {
  hasUnverifiedUserRoles: boolean;
}

const Home: Page = () => {
  const router = useRouter();
  const { data: session, status } = useSession();
  const user = session?.user as UserInfo;
  const permissionKeys = useAtomValue(permissionsAtom);
  const { fetchGET } = useFetchWithAccessToken();

  useEffect(() => {
    if (status === "loading" || permissionKeys == null) return;
    console.log(user)
    const handleRouting = async () => {
      // const manajemenAnggotaPermissions = [
      //   "akses_sidebar_pendaftaran_anggota",
      //   "akses_sidebar_ubah_data_sekolah_yayasan",
      //   "akses_sidebar_submit_lulusan",
      //   "akses_sidebar_pembayaran_iuran",
      //   "akses_sidebar_validasi_iuran_non_payment",
      // ];

      // const hasManajemenAnggotaAccess = manajemenAnggotaPermissions.some(p =>
      //   permissionKeys.includes(p)
      // );
      if (user?.role?.length === 2
        && user?.role?.includes('f2b93d46-2156-4470-bf6f-7e4f4c2f1a8b')
        && user?.role?.includes('0792ea85-7816-4907-b50b-f495d0fc67b8')) {
        if (user?.id) {
          const response = await fetchGET<CheckUnverifiedResponse>(
            `${BackendApiUrl.access.getUserHasUnverifiedRole}?Id=${user.id}`
          );

          if (response?.data && response.data.hasUnverifiedUserRoles === true) {
            router.replace('/no-role-access');
          } else {
            router.replace('/first-time-access');
          }

          // // Additional check for "Manajemen Anggota" role
          // if(!hasManajemenAnggotaAccess && permissionKeys.length == 0) {
          //     router.replace('/no-role-access-manajemen-anggota');
          // }
        }
      }
      else {
        router.replace('/dashboard');
      }
    };

    handleRouting();
  }, [router, user, status, permissionKeys]);

  if (status == "loading") {
    return (
      <em>Loading...</em>
    )
  }

  return null;
};

Home.layout = WithDefaultLayout;
export default Home;